// extracted by mini-css-extract-plugin
export default {"wrap":"Links_wrap__yT7hB","btn":"Links_btn__DSR8c"};